module.exports = __webpack_public_path__ + "assets/edit_blue-64b04c.svg";